import { AbstractComponent } from "appworks/components/abstract-component";
import { Layers } from "appworks/graphics/layers/layers";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Timer } from "appworks/utils/timer";
import { JurisdictionService } from "slotworks/services/jurisdiction/jurisdiction-service";

export class JurisdictionComponent extends AbstractComponent {
    protected readonly OVERRIDE_POSITION: string = "override_position";
    protected readonly MIN_SPIN_BUFFER: number = 100;
    private spinStartTime?: number;

    public init(): void {
        Layers.get("Jurisdiction").onSceneEnter.add(() => {
            this.updatePosition();
        });
    }

    public startSpin(): void {
        this.spinStartTime = Date.now();
        uiFlags.set(UIFlag.MIN_SPIN_COOLDOWN, true);
        Timer.setTimeout(() => uiFlags.set(UIFlag.MIN_SPIN_COOLDOWN, false), Services.get(JurisdictionService).getMinimumSpinTime());
    }

    public waitForMinSpin(): Contract<void> {
        if (this.spinStartTime !== undefined) {
            const minSpinTime: number = Services.get(JurisdictionService).getMinimumSpinTime() + this.MIN_SPIN_BUFFER;
            const elapseTime: number = Date.now() - this.spinStartTime;
            const remainingTime: number = minSpinTime - elapseTime;
            this.spinStartTime = undefined;

            if (remainingTime <= 0) {
                return Contract.empty();
            } else {
                return Contract.getTimeoutContract(remainingTime);
            }
        } else {
            return Contract.empty();
        }
    }

    protected updatePosition(): void {
        const layer = Layers.get("Jurisdiction");
        const landscape = layer?.getPosition(this.OVERRIDE_POSITION)?.landscape;
        const portrait = layer?.getPosition(this.OVERRIDE_POSITION)?.portrait;
        if (layer && landscape && portrait) {
            const updatePosition = (element: Sprite | Text) => {
                if (element) {
                    element.landscape.x = landscape.x + element.landscape.x;
                    element.landscape.y = landscape.y + element.landscape.y;
                    element.portrait.x = portrait.x + element.portrait.x;
                    element.portrait.y = portrait.y + element.portrait.y;
                }
            };

            layer.container.children.forEach((child) => {
                if (child instanceof Sprite || child instanceof Text) {
                    updatePosition(child);
                }
            });
        }
    }
}
